import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PayumoneyPaymentService } from 'src/app/core/services/payumoney-payment.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  public currentUser = JSON.parse(localStorage.getItem('currentUser'));

  constructor(public payumoneyPaymentService: PayumoneyPaymentService,
  public router: Router) { }
  public currentUserDetails = this.currentUser

  ngOnInit(): void {
  }


  printAndOpenReceipt() {
    // let url =  this.router.navigate(['/pages/print-receipt'])
    window.open('/#/auth/print-receipt');
  }
}
